import React from 'react';
import { useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { getPasswordFormErrorLabel } from 'src/shared/helpers';

import { Button } from '@alfalab/core-components/button/cssm';
import { PasswordInput } from '@alfalab/core-components/password-input';
import { Space } from '@alfalab/core-components/space/cssm';
import { Typography } from '@alfalab/core-components/typography';

import { PasswordRecoveryModal } from '../password-recovery-modal';

const PASSWORD_MINIMUM_LENGTH = 6;

export const PasswordForm = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const {
        register,
        formState: { isValid },
    } = useForm();

    const errorCode = searchParams.get('failure-reason');

    const onChange = () => {
        if (searchParams.has('error')) {
            setSearchParams((params) => {
                params.delete('error');

                return params;
            });
        }
    };

    return (
        <div className='authForm'>
            <Space direction='vertical' size={24} fullWidth={true}>
                <Typography.Title view='small' tag='div'>
                    Осталось ввести пароль
                </Typography.Title>
                <form className='apmui-form' id='auth_form' method='POST' action='/my.policy'>
                    <Space direction='vertical' size={32} fullWidth={true}>
                        <PasswordInput
                            block={true}
                            label='Пароль'
                            type='password'
                            size='m'
                            id='password'
                            autoCapitalize='off'
                            error={getPasswordFormErrorLabel(errorCode)}
                            autoFocus={true}
                            {...register('password', {
                                required: 'required',
                                minLength: PASSWORD_MINIMUM_LENGTH,
                                onChange,
                            })}
                        />
                        <Space direction='vertical' size={16} fullWidth={true}>
                            <Button
                                view='primary'
                                size='m'
                                block={true}
                                type='submit'
                                disabled={!isValid}
                            >
                                Продолжить
                            </Button>
                            <PasswordRecoveryModal />
                        </Space>
                    </Space>
                </form>
            </Space>
        </div>
    );
};
